export default __webpack_public_path__ + "static/media/A_Aranha.f20cedee.mp3";